import * as _ from "lodash";
import { Components } from "formiojs";

const TextFieldComponent = Components.components.textfield;

export default class MiproPatientNameTextField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproPatientNameTextField",
            label: "Patient",
            key: "dbo.mipro.miproPatientName",
            placeholder: "Enter Patient Name", 
            disabled: false, 
            input: true,
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Patient",
            group: "basic",
            icon: "user-md",
            weight: 70,
            schema: MiproPatientNameTextField.schema(),            
        };
    }
}

Components.addComponent("miproPatientNameTextField", MiproPatientNameTextField);